import actions from '../actions';

const initState = {
  id: null,
  uid: null,
  name: null,
  currency: null,
  logo_url: null,
  loading: false
};

export default function marketplaceReducer(state = initState, action) {
  switch (action.type) {
    case actions.marketplace.INIT:
      return { ...initState };
    case actions.marketplace.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
